
import axiosAuthConfig from '../../axiosAuthConfig';

export const getProfile = async () => {
    try {
        const response = await axiosAuthConfig.get(`/api/user/getProfile`); // Call your protected API endpoint
        return response.data; // Return the data from the response
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};